export default __webpack_public_path__ + "67d6dbfcd04f0c186641334c073ca28b.png";